export default __webpack_public_path__ + "5c9febce52054ae0b96ddd3e2d173e1a.woff";